module.exports = __webpack_public_path__ + "6a7090c10c130bab16aaaec901064a60.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/sounds/send-message.mp3
// module id = 1125
// module chunks = 0